module.exports = __webpack_public_path__ + "assets/img/we_logo.4d2953ce.png";